import { useEffect, useState } from "react";


export const useCurrentLocation = () => {
  const [state, setState] = useState({
    lat: 19.432307,
    lng: -99.133550,
  });
  useEffect(() =>{
  if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (data) => {
          const pos = {
            lat: data.coords.latitude,
            lng: data.coords.longitude,
          };
          setState(pos);
        },
        () => {
          console.log("Error al obtener localización");
        }
      );
                          
  }
  else {
  }
},[])
  return state;
}
